export const CHAT_USER_EXPIRY_SWEEP_INTERVAL_MS = 1_000;

export function pruneExpiredChatUsers<
    Entry extends { readonly expiresAt: number },
>(entries: Record<string, Entry>, nowMs: number): Record<string, Entry> {
    const remaining = Object.fromEntries(
        Object.entries(entries).filter(([, entry]) => entry.expiresAt > nowMs),
    );
    return Object.keys(remaining).length === Object.keys(entries).length
        ? entries
        : remaining;
}
